import SubmitVoteMessage from './SubmitVoteMessage';

export default SubmitVoteMessage;
